module.exports = __webpack_public_path__ + "Server-Default.TentaclePassive.1a88f4f7e6db6d5363ebc753ada151b1.hashedasset.svg";